import { render, staticRenderFns } from "./RatingUserDirectionsIndexRootView.vue?vue&type=template&id=8a7177f0"
import script from "./RatingUserDirectionsIndexRootView.vue?vue&type=script&lang=js"
export * from "./RatingUserDirectionsIndexRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports